export default "__VITE_ASSET__CcHDoHPl__"